// extracted by mini-css-extract-plugin
module.exports = {"input":"jsonInput__input___2Qz6r"};